import { useCookies } from 'react-cookie';
import { useCallback } from 'react';

export const useStorageManager = () => {
    const [cookies, setCookie, removeCookie] = useCookies();

    const setItemToStorage = useCallback(
        (key, value, isRemove = false) => {
            const cookiesOptions = {
                path: '/',
                secure: true, // Required for SameSite=None
                sameSite: 'None',
            };
            if (isRemove) {
                sessionStorage.removeItem(key);
                removeCookie(key);
            } else {
                sessionStorage.setItem(key, value);
                setCookie(key, value, cookiesOptions);
            }
        },
        [setCookie, removeCookie]
    );

    const getItemFromStorage = useCallback(
        key => {
            const cookieValue = cookies[key];
            const storageValue = sessionStorage.getItem(key);
            return cookieValue || storageValue;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return { setItemToStorage, getItemFromStorage };
};
